function isStunUrl(url: string): boolean {
  return /^stuns?:/i.test(url);
}

/**
 * Native video may receive TURN credentials through the Electron peer config,
 * but TURN is opt-in. Do not advertise relay candidates unless the peer was
 * explicitly configured for relay transport.
 */
export function nativeIceServers(config: RTCConfiguration): RTCIceServer[] {
  const servers = config.iceServers ?? [];
  if (config.iceTransportPolicy === 'relay') return servers;

  return servers.flatMap(server => {
    const urls = typeof server.urls === 'string' ? [server.urls] : server.urls;
    const stunUrls = urls.filter(isStunUrl);
    if (!stunUrls.length) return [];
    return [{ ...server, urls: typeof server.urls === 'string' ? stunUrls[0] : stunUrls }];
  });
}
